module.exports = __webpack_public_path__ + "img/bx.f0a47209.gif";